export default __webpack_public_path__ + "2b472753f0a8828ff01d2181038a51c6.svg";